
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.344 2.668l.517-1.038-.442-.22L12 .83 11.193 0l-.58.58-.221-.44-1.04.515.396.79-.267.266a5.81 5.81 0 00-7.98.598 5.796 5.796 0 00.2 7.992 5.808 5.808 0 009.893-3.667A5.796 5.796 0 0010.3 2.53l.267-.267.778.406zm-.9 3.543a4.637 4.637 0 01-3.589 4.527 4.648 4.648 0 01-5.223-2.473 4.636 4.636 0 011.233-5.641 4.647 4.647 0 015.78-.072l-.83.823a3.486 3.486 0 00-4.68.589A3.478 3.478 0 005.65 9.687a3.485 3.485 0 003.6-3.042 3.477 3.477 0 00-.617-2.452l.83-.823c.634.812.979 1.812.981 2.841zm-2.322 0a2.318 2.318 0 01-2.775 2.276 2.323 2.323 0 01-1.825-1.823A2.318 2.318 0 015.8 3.892c.41.006.81.12 1.161.33l-1.4 1.41H5.22v1.16H6.38v-.343l1.411-1.397c.21.35.325.75.331 1.16z"}})])
          )
        }
      }
    